import { useEffect, useState } from "react";
import { FolderLock, Download } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import api, { API } from "@/lib/api";

export const DataRoomsPanel = ({ companyId }) => {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/portal/companies/${companyId}/data-rooms`); setRooms(data); }
      catch (e) { console.error("Failed to load data rooms", e); }
    })();
  }, [companyId]);

  if (rooms.length === 0) return null;

  const open = async (room, doc) => {
    try { await api.post(`/portal/data-rooms/${room.id}/view`, { doc_id: doc.id }); }
    catch (e) { console.error("View log failed", e); }
    window.open(`${API}/documents/${doc.id}/download`, "_blank");
  };

  return (
    <div data-testid="investor-datarooms-panel">
      <h2 className="mb-3 flex items-center gap-2 h-display text-lg font-semibold text-foreground"><FolderLock className="h-5 w-5 text-primary" /> Data rooms</h2>
      <div className="space-y-3">
        {rooms.map((r) => (
          <Card key={r.id} className="rounded-xl border bg-card p-4" data-testid={`investor-room-${r.id}`}>
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-foreground">{r.name}</span>
              <Badge variant="secondary" className="font-normal">{r.documents.length} docs</Badge>
            </div>
            {r.description && <p className="mt-0.5 text-xs text-muted-foreground">{r.description}</p>}
            <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
              {r.documents.map((d) => (
                <button key={d.id} onClick={() => open(r, d)}
                  className="flex items-center justify-between rounded-lg border p-2.5 text-left transition-colors hover:border-primary/40"
                  data-testid={`investor-room-doc-${d.id}`}>
                  <div className="min-w-0">
                    <div className="truncate text-xs font-medium text-foreground">{d.name}</div>
                    <div className="text-[10px] text-muted-foreground">{d.category}</div>
                  </div>
                  <Download className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
                </button>
              ))}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
